import { t } from "@lingui/macro";

import { ToggleSwitch } from "@whoosh/design-system/src/components/controls";
import { LoyaltyIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { useLoyaltyEnrollmentPreference } from "../LoyaltyEnrollmentPreference/LoyaltyEnrollmentPreference";

type EnrollmentProps = {
  points: number;
  terminologyOne: string;
  terminologyOther: string;
};

export const PatronCheckoutLoyaltyEnrollment = ({
  points,
  terminologyOne,
  terminologyOther,
}: EnrollmentProps) => {
  const scopedPreference = useLoyaltyEnrollmentPreference();
  if (!scopedPreference) return null;
  const { preference, setPreference } = scopedPreference;
  const terminology = points === 1 ? terminologyOne : terminologyOther;

  return (
    <VStack gap={4} testID="loyalty-enrollment-offer">
      <Box height={1} backgroundColor="outline-default" width="100%" />
      <HStack alignItems="center" justifyContent="space-between" gap={4}>
        <HStack alignItems="center" gap={3} flex={1}>
          <Box
            width={48}
            height={48}
            borderRadius="8"
            backgroundColor="surface-secondary"
            alignItems="center"
            justifyContent="center"
          >
            <LoyaltyIcon color="icon-primary" width={24} height={24} />
          </Box>
          <VStack flex={1}>
            <Text variant="mainBaseSemiBold" color="text-primary">
              {t`Join Rewards Program`}
            </Text>
            <Text variant="mainSmall" color="text-secondary">
              {t`Earn ${points} ${terminology} on this order`}
            </Text>
          </VStack>
        </HStack>
        <ToggleSwitch
          isChecked={preference}
          onToggle={setPreference}
          accessibilityLabel={t`Join Rewards Program`}
          testID="loyalty-enrollment-toggle"
        />
      </HStack>
    </VStack>
  );
};
